var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.934 15.244-1.887-1.209a.374.374 0 0 1-.12-.507l7.286-12.165A.75.75 0 0 1 14.856 1h1.718c.264 0 .503.14.642.363l7.286 12.165a.374.374 0 0 1-.12.507l-1.887 1.21a.38.38 0 0 1-.523-.125l-6.1-10.18c-.07-.12-.244-.12-.32 0L9.458 15.12a.372.372 0 0 1-.523.124zM26.42 16.73l2.903 4.845c.204.348.1.796-.244 1.01L16.115 30.88a.74.74 0 0 1-.807 0L2.344 22.586a.742.742 0 0 1-.239-1.01l2.904-4.844a.372.372 0 0 1 .523-.123l1.887 1.208c.17.11.224.334.12.508L5.88 21.088a.19.19 0 0 0 .061.254l9.678 6.192c.06.04.14.04.199 0l9.671-6.192a.19.19 0 0 0 .06-.254l-1.658-2.765a.374.374 0 0 1 .12-.508l1.887-1.208a.38.38 0 0 1 .523.124z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRep);
export default __webpack_public_path__ + "static/media/REP.c17cd2d164066103ec76110a96e1758e.svg";
export { ForwardRef as ReactComponent };